window.tinyMCE.PluginManager.add('tablesorting', function (editor) {
  function sortTable(order) {
    const table = editor.dom.getParent(editor.selection.getNode(), 'table');
    if (!table) {
      editor.windowManager.alert('Please place the cursor inside a table.');
      return;
    }

    const thead = table.querySelector('thead');
    const tbody = table.querySelector('tbody');
    if (!tbody) {
      editor.windowManager.alert('The table does not have a tbody.');
      return;
    }

    const headerRow = thead ? thead.rows[0] : tbody.rows[0]; // Check the first row of thead or tbody for headers
    const headerCells = Array.from(headerRow.cells);

    // Check if all headers are numbers or all are text
    const allHeadersAreNumbers = headerCells.every(cell => !isNaN(parseFloat(cell.innerText)));
    const allHeadersAreText = headerCells.every(cell => isNaN(parseFloat(cell.innerText)));

    if (!(allHeadersAreNumbers || allHeadersAreText)) {
      editor.windowManager.alert(
        'Cannot sort the table. Headers must be either all text or all numbers.'
      );
      return;
    }

    const selectedCell = editor.selection.getNode();
    const selectedColumnIndex = Array.from(selectedCell.parentNode.children).indexOf(selectedCell);

    const rows = Array.from(tbody.rows);

    if (allHeadersAreNumbers) {
      rows.unshift(headerRow);
    } else {
      rows.shift();
    }

    // Sort rows based on the selected column
    rows.sort((rowA, rowB) => {
      const cellA = rowA.cells[selectedColumnIndex].innerText;
      const cellB = rowB.cells[selectedColumnIndex].innerText;

      // Convert to numbers if all headers are numbers
      if (allHeadersAreNumbers) {
        const numA = parseFloat(cellA) || 0;
        const numB = parseFloat(cellB) || 0;
        if (numA < numB) {
          return order === 'asc' ? -1 : 1;
        }
        if (numA > numB) {
          return order === 'asc' ? 1 : -1;
        }
      } else {
        if (cellA < cellB) {
          return order === 'asc' ? -1 : 1;
        }
        if (cellA > cellB) {
          return order === 'asc' ? 1 : -1;
        }
      }
      return 0;
    });

    // Append sorted rows back to tbody
    rows.forEach(row => tbody.appendChild(row));
  }

  editor.ui.registry.addButton('sortasc', {
    text: 'Sort Ascending',
    onAction: function () {
      sortTable('asc');
    }
  });

  editor.ui.registry.addButton('sortdesc', {
    text: 'Sort Descending',
    onAction: function () {
      sortTable('desc');
    }
  });

  editor.on('contextmenu', function (e) {
    const table = editor.dom.getParent(editor.selection.getNode(), 'table');
    if (table) {
      e.preventDefault();
      editor.windowManager.open({
        title: 'Sort Table',
        body: {
          type: 'panel',
          items: [
            {
              type: 'button',
              name: 'sortasc',
              text: 'Sort Ascending',
              onClick: function () {
                sortTable('asc');
                editor.windowManager.close();
              }
            },
            {
              type: 'button',
              name: 'sortdesc',
              text: 'Sort Descending',
              onClick: function () {
                sortTable('desc');
                editor.windowManager.close();
              }
            }
          ]
        },
        buttons: [
          {
            text: 'Close',
            type: 'cancel',
            onClick: 'close'
          }
        ]
      });
    }
  });
});
